import { openModal } from '@/components/commons/Dialog/Dialog.vue';
import IFinancingProvider from './IFinancingProvider';
import affirm_initialize from './affirm_init.js';
import { defineAsyncComponent } from 'vue';

export default {
  load(key, url) {
    if (window['affirm']) {
      return;
    }

    const affirmConfig = {
      public_api_key: key,
      script: url,
    };

    affirm_initialize(window, affirmConfig, 'affirm', 'checkout', 'ui', 'script', 'ready', 'jsReady');

    window['affirm'].articleConfig = {
      key,
      url,
    };
  },

  refresh(config) {
    this.load(config.affirmKey, config.affirmUrl);
    try {
      window['affirm'].ui.ready(function () {
        window['affirm'].ui.refresh();
      });
    } catch (e) {
      console.error('Failed to refresh Affirm');
      console.error(e);
    }
  },

  async estimatePayment(amountInCents, financingConfig, _options) {
    this.load(financingConfig.affirmKey, financingConfig.affirmUrl); // loading in 2 places?
    return new Promise((resolve, reject) => {
      if (!amountInCents || amountInCents < 5000 || amountInCents > 3000000) {
        throw new Error('Unable to provide Affirm estimates for amounts less than $50 or more than $30000');
      }

      const options = {
        apr: '0.10', // percentage assumed APR for loan
        months: 12, // can be 3, 6, or 12
        ..._options,
        amount: amountInCents, // USD cents
      };

      const affirm = window['affirm'];

      if (affirm && affirm.ui && affirm.ui.ready) {
        affirm.ui.ready(() => {
          if (affirm && affirm.ui && affirm.ui.payments && affirm.ui.payments.get_estimate) {
            affirm.ui.payments.get_estimate(options, (paymentEstimate) => {
              const dollars = ((paymentEstimate.payment + 99) / 100) | 0; // get dollars, round up, and convert to int
              const modalUrl = this.modalUrl(amountInCents);
              const openEstimateModal = this.openModalForUrl.bind(this, modalUrl);
              resolve({
                estimateAvailable: true,
                provider: 'affirm',
                monthlyPayment: dollars,
                modalUrl,
                openNativeModal: paymentEstimate.open_modal ?? openEstimateModal,
                openModal: openEstimateModal,
              });
            });
          }
        });
      }
    });
  },

  openModalForUrl(url) {
    openModal(
      defineAsyncComponent(() => import('@/components/commons/Dialog/AffirmModal.vue')),
      {
        url: url,
      },
      {
        showClose: false,
        urlFragment: 'affirm-estimate',
        padding: false,
      },
    );
  },

  modalUrl(amount) {
    return `https://${this.getModalHost()}/apps/prequal/?public_api_key=${
      window['affirm'].articleConfig.key
    }&unit_price=${amount}&page_type=payment&use_promo=true`;
  },

  preQualifyModalUrl() {
    return `https://${this.getModalHost()}/apps/prequal/?public_api_key=${
      window['affirm'].articleConfig.key
    }&page_type=landing&unit_price=&use_promo=true`;
  },

  getModalHost() {
    const isProd = !window['affirm'].articleConfig.url.includes('sandbox');
    return isProd ? 'www.affirm.com' : 'sandbox.affirm.com';
  },

  openPrequalifyModal() {
    this.openModalForUrl(this.preQualifyModalUrl());
  },
} as IFinancingProvider;
